import * as React from 'react';

export const CrossGray = (
  <svg width='9' height='9' viewBox='0 0 9 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M0.75 8.24965L8.25 0.749649' stroke='#656B6F' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8.25 8.24965L0.75 0.749649' stroke='#656B6F' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
